// @ts-nocheck
import React, { useEffect, useState, useTransition, useRef } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Clear";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import {
  Typography,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Checkbox,
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
  InputAdornment,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Dialog,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CircularProgress from "@mui/material/CircularProgress";
import {
  AddproxyBid,
  cancelProxyBid,
  getProxyBidId,
  handleUpdateProxyBid,
} from "../services/Api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../services/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { MyBidApi } from "../redux/slice/mybidSlice";
import { toast } from "react-toastify";
import { FetchProfileList } from "../redux/slice/PurchaseProfileList";

export default function RightSidebar({
  isOpen,
  toggleSidebar,
  setIsModalOpen,
  activeStep,
  auctionId,
  // setActiveStep,
  completed,
  setCompleted,
  openingBid,
  auctionReservePrice,
  purchaseProfiles


}) {
  const { investorId: { investorId, username } } = useAuth();
  // const [completed, setCompleted] = useState({ 0: true, 1: false });
  const [selectedProfile, setSelectedProfile] = useState(investorId);

  const [expanded, setExpanded] = useState([true, false]);
  const [proxyBidPrice, setProxyBidPrice] = useState(0);
  const [isBidProtectionEnable, setIsBidProtectionEnable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [PlaceBidText, setPlaceBidText] = useState("Update Bid");
  const [errors, setErrors] = useState("");
  const [boxOpen, setBoxOpen] = useState(false);
  const [oldProxybid, setOldProxyBid] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [bidamount, setBidAmount] = useState(0)
  // const [updateProxyBid, setUpdateProxyBid] = useState(true)
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { userData } = useSelector((state) => state.user);
  const [isPending, startTransition] = useTransition();
  const profileList = useSelector((state) => state?.purchaseProfile?.profiles?.body);
  const inputRef = useRef(null);

  useEffect(() => {
    dispatch(FetchProfileList(investorId));
  }, [isOpen])


  let proxybidData = {};
  // Move fetchProxyBidValue out as a standalone function
  const fetchProxyBidValue = async () => {
    setLoading(true);
    try {
      // Always use investorId (from auth) for the API call
      const response = await getProxyBidId(investorId, auctionId);
      if (response.data) {
        setProxyBidPrice(formatToDollar(response.data.preauctionBidAmount));
        setBidAmount(response.data.preauctionBidAmount);
        setSelectedProfile(response.data.purchaseProfileId); // This updates the profile for the auction
        setIsBidProtectionEnable(response.data.bidProtectionEnabled);
        setCompleted({ 0: true, 1: true });
        setPlaceBidText("Update Bid");
        setOldProxyBid(formatToDollar(response.data.preauctionBidAmount));
      }
    } catch (error) {
      setErrors(error.response?.data?.message);
      console.log(error.response?.data)
    } finally {
      setLoading(false);
    }
  };

  // Call fetchProxyBidValue when modal is opened
  useEffect(() => {
    if (isOpen) {
      fetchProxyBidValue();
    }
    // No resetForm here; handle resetForm on close
    // eslint-disable-next-line
  }, [isOpen, auctionId]);

  const handleRadioChange = (event) => {
    setSelectedProfile(parseInt(event.target.value));
    setCompleted((prev) => ({ ...prev, 0: true }));
    setExpanded((prev) => {
      const newExpanded = [...prev];
      newExpanded[1] = true;
      return newExpanded;
    });
    // setActiveStep(1);
  };
  const steps = [
    {
      label: "Select a purchase profile",
    },
    {
      label: "Enter your Proxy Bid",
    },
  ];

const resetForm = () => {
  setIsBidProtectionEnable(false);
  setProxyBidPrice(0);
  // setActiveStep(0);
  // setCompleted({ 0: true, 1: false });
  setExpanded([true, false]);
  setMessage("");
  setErrors("");
  setPlaceBidText("Update Bid");
  setOldProxyBid(null);
  // setUpdateProxyBid(true)
};

function formatToDollar(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    // currency: "USD",
    minimumFractionDigits: 0, // No decimal places
    maximumFractionDigits: 0,
  }).format(amount);
}

useEffect(() => {
  if(bidamount < auctionReservePrice){
  setButtonDisabled(true)
      setErrors(`Proxy bid must be in multiples of $1,000 and above  $${formatToDollar(auctionReservePrice)}`);
}
else{
  setButtonDisabled(false)
  setErrors("");
}

},[bidamount])

const handlePriceChange = (event) => {
  const input = event.target;
  const rawValue = input.value.replace(/[^0-9]/g, "");
  const selectionStart = input.selectionStart;

  // Count digits before the cursor in the old value
  let digitsBeforeCursor = 0;
  for (let i = 0; i < selectionStart; i++) {
    if (/\d/.test(input.value[i])) digitsBeforeCursor++;
  }

  if (rawValue === "") {
    setProxyBidPrice("");
    setBidAmount(0);
    setErrors("");
    return;
  }

  const numericValue = parseInt(rawValue, 10);

  if (!isNaN(numericValue)) {
    // Check if amount is in multiples of 1000
    const formattedAmount = formatToDollar(numericValue);

    // Find the new cursor position: after the same number of digits
    let newCursor = 0, digitCount = 0;
    while (newCursor < formattedAmount.length && digitCount < digitsBeforeCursor) {
      if (/\d/.test(formattedAmount[newCursor])) digitCount++;
      newCursor++;
    }
    // If we're at the end of the input and adding a digit, stay at the end
    if (selectionStart === input.value.length && digitsBeforeCursor === rawValue.length - 1) {
      newCursor = formattedAmount.length;
    }

    if (numericValue % 1000 !== 0 || numericValue < auctionReservePrice) {
      setButtonDisabled(true);
      setErrors(`Proxy bid must be in multiples of $1,000 and above $${formatToDollar(auctionReservePrice)}`);
    } else {
      setButtonDisabled(false);
      setErrors("");
    }
    setProxyBidPrice(formattedAmount); // Set the formatted value
    setBidAmount(numericValue);

    setTimeout(() => {
      // Access the actual input element inside the TextField
      const inputElement = inputRef.current?.querySelector('input') || input;
      if (inputElement) {
        inputElement.setSelectionRange(newCursor, newCursor);
      }
    }, 0);
  } else {
    setErrors("Please enter a valid number.");
    setButtonDisabled(true);
  }
};

const handleclose = (event) => {
  resetForm();
  setSelectedProfile([])
  toggleSidebar(false, event);
};

const handleCancelProxyBid = async () => {
  setLoading(true)
  try {
    const response = await cancelProxyBid(investorId, auctionId);

    // Check for successful response based on the responseMessage
    if (response && response.responseMessage) {
      setLoading(false)
      setMessage(response.responseMessage); // Use the responseMessage for user feedback
      handleboxClose();
      setIsModalOpen(false)
      setTimeout(() => {
        resetForm();
      }, 3000);
      dispatch(MyBidApi(parseInt(investorId)))
    } else {
      console.error("Failed to cancel proxy bid. Response:", response);
      setErrors("Failed to cancel proxy bid. Please try again.");
    }
  } catch (error) {
    console.error("Error canceling proxy bid:", error.response.data);
    if (error.response.data) {
      setErrors(error.response.data.message);
      setLoading(false)
    }
  }
};

 const OnUpdateProxyBid = async (event) => {
    const proxybidData = {
      investorId: investorId,
      auctionId,
      purchaseProfileId: selectedProfile,
      proxyBidPrice: parseInt(proxyBidPrice?.replace(/,/g, ""), 10) || 0,
      isBidProtectionEnable,
      bidderId: `${investorId}`,
    };
    try {
      if (investorId && auctionId) {
        // Check if the new proxy bid is the same as the old one
        if (proxyBidPrice === oldProxybid) {
          setErrors("Please update the proxy bid amount.");
          setTimeout(() => {
            setErrors("");
          }, 2000);
          return; // Return early to prevent API call
        }
        setLoading(true);
        const { response } = await handleUpdateProxyBid(
          investorId,
          auctionId,
          proxybidData
        );
        toast.success(response.message, {
          className: 'custom-toast'
        });
        dispatch(MyBidApi(parseInt(investorId)))
        resetForm();
        setIsModalOpen(false)
        setLoading(false)

      }
    } catch (error) {
      setLoading(false)
      setErrors(error?.response?.data?.message);
    } finally {
    }
  };
// const OnUpdateProxyBid = async () => {
//   setLoading(true)
//   const proxybidData = {
//     investorId: investorId,
//     auctionId,
//     purchaseProfileId: selectedProfile,
//     proxyBidPrice: parseInt(proxyBidPrice?.replace(/,/g, ""), 10) || 0,
//     isBidProtectionEnable,
//     bidderId: `${investorId}`,
//   };
//   try {
//     if (selectedProfile && auctionId) {
//       // Check if the new proxy bid is the same as the old one
//       if (proxyBidPrice === oldProxybid) {
//         setErrors("Update the proxy bid");
//         setTimeout(() => {
//           setErrors("")
//         }, 2000);
//         return; // Return early to prevent API call
//       }

//       const {response} = await handleUpdateProxyBid(
//         investorId,
//         auctionId,
//         proxybidData
//       );
//       console.log(response,"proxy")
//       setLoading(false)
//       setMessage(response.message);
//       setTimeout(() => {
//         setIsModalOpen(false)
//       }, 1000)
     
//     }
//   } catch (error) {
//     console.error("Error updating proxy bid:-", error.response.data);
//     setErrors(error.response.data.message);
//     setLoading(false)
//   }
// };

// Remove this useEffect that calls OnUpdateProxyBid automatically
// useEffect(() => {
//   OnUpdateProxyBid()
// }, [auctionId])

const isboxOpen = () => {
  setBoxOpen(true);
};

const handleboxClose = () => {
  setBoxOpen(false);

};

const handleNavigating = () => {
  try {
    startTransition(() => {
      navigate("/purchaseprofile/identity-verification", { replace: true });
    });
  } catch (error) {
    console.error("Navigation error:", error);
    // Fallback direct navigation
    window.location.href = "/purchaseprofile/identity-verification";
  }
};

return (
  <>
    <Dialog
      open={boxOpen}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleboxClose();
        }
      }}
      fullWidth
      maxWidth="sm"
      sx={{
        zIndex:"9999999",
        "& .MuiDialog-paper": {
          padding: { xs: 2, sm: 3 },
      
        },
      }}
    >
      <Box
        sx={{
          padding: 3,
          backgroundColor: "#F8F8F8",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
        }}
      >
        <ErrorOutlineIcon
          sx={{
            fontSize: { xs: "24px", sm: "28px" },
            color: "#FF5C39",
          }}
        />
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: { xs: "16px", sm: "20px" },
            lineHeight: "30px",
            textAlign: "center",
          }}
        >
          Are you sure you want to cancel your proxy bid?
        </Typography>
        <div
          className="flex-row mt-5"
          style={{
            width: "30%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={handleboxClose}
            variant="outlined"
            size="medium"
            sx={{
              px: 2,
              py: 1,
              borderColor: "#FF5C39",
              textTransform: "none",
              width: "60%",
              marginRight: { xs: 1, sm: 2 },
              color: "#FF5C39",
              backgroundColor: "transparent",
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{
              px: 2,
              py: 1,
              backgroundColor: "#FF5C39",
              textTransform: "none",
              width: "60%",
              color: "white",
            }}
            onClick={handleCancelProxyBid}
          >
            Yes
          </Button>
        </div>
      </Box>
    </Dialog>
    <Dialog 
      open={isOpen} 
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          setIsModalOpen(false);
        }
      }}
      fullWidth 
      maxWidth="sm"
      sx={{
        zIndex:"9999999",
      }}
    >
      {/* Loader while fetching data */}
      {loading ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          minHeight='80vh'
        >
          <CircularProgress sx={{ color: "#faaf19" }} />
        </Box>
      ) : (
        <Box p={1} sx={{maxHeight: '80vh'}}>
          <Box display="flex" justifyContent="space-between" alignItems="center" >
            <Typography
              sx={{ fontWeight: 600, fontSize: "22px", lineHeight: "39px" }}
            >
              Place Your Bid
            </Typography>
            <div>
              {/* {oldProxybid && ( */}
              <span
                onClick={isboxOpen}
                id="cancel-proxy-bid"
                className="text-[#FF5C39] underline text-[12px] font-medium mr-1 cursor-pointer"
              >
                Cancel Proxy Bid
              </span>
              {/* )} */}

              <IconButton
                onClick={() => setIsModalOpen(false)}
                sx={{
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focusVisible": {
                    outline: "none",
                  },
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <CloseIcon
                  sx={{
                    fontSize: { xs: "24px", sm: "28px" },
                    color: "#3B3B3B",
                  }}
                />
              </IconButton>
            </div>
          </Box>
          <Divider sx={{ my: 1 }} /> {/* Adjusted spacing around the Divider */}
          {/* Proxy Bid Card Start*/}
          <Box
            mt={2}
            sx={{ backgroundColor: "white", boxShadow: 3, borderRadius: 1, p: 2 }}
          >
            <Stepper
              activeStep={activeStep}
              orientation="vertical"
              nonLinear={true}
            >
              {steps.map((step, index) => (
                <Step
                  key={step.label}
                  //  / completed={completed[index]}
                  expanded={true}

                >
                  <StepLabel
                    StepIconProps={{
                      sx: {
                        "&.Mui-completed": {
                          color: "green",
                        },

                      },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <Typography sx={{}} fontWeight={500} className="text-[18px] font-medium leading-[27px]">
                        {step.label}
                      </Typography>
                    </Box>
                  </StepLabel>
                  <StepContent>
                    <Box sx={{ ml: 2, mt: 1 }}>
                      {index === 0 && (
                        <Paper variant="outlined" sx={{ pt: 1, pl: 2 }}>
                          <RadioGroup
                            value={selectedProfile}
                            onChange={handleRadioChange}
                          >
                           
                            {profileList?.map((account, index) => (
                              <FormControlLabel
                                key={account?.investorId}
                                value={account?.investorId}
                                control={
                                  <Radio
                                    sx={{
                                      color: "black",
                                      "&.Mui-checked": { color: "#FF5C39" },
                                    }}
                                  />
                                }
                                sx={{
                                  borderBottom: index !== purchaseProfiles?.length - 1 ? 1 : 0,
                                  borderBottomColor: "#C5C9CD",
                                }}
                                label={
                                  <Typography variant="body1">
                                    {account?.profileName?.length > 1 ? account?.profileName : account?.firstName} ({account?.userType?.charAt(0)?.toUpperCase() + account?.userType?.slice(1)}) 
                                  </Typography>
                                }
                              />
                              
                            ))}
                          </RadioGroup>

                          <Typography
                            sx={{
                              cursor: "pointer",
                              color: "#FF5C39",
                              fontSize: "14px",
                              fontWeight: 500,
                              textDecoration: "underline",
                              pb: 1
                            }}
                            onClick={() =>
                              // setExpanded((prev) => ({ ...prev, 0: true }))
                              handleNavigating()
                            }
                          >
                            Add new purchase profile
                          </Typography>

                        </Paper>
                      )}
                      {index === 1 && (
                        <Box>
                          <TextField
                            fullWidth
                            label="Amount"
                            variant="outlined"
                            value={proxyBidPrice}
                            id="update-proxy-bid"
                            onChange={handlePriceChange}
                            inputRef={inputRef}
                            slotProps={{
                              input: {
                                startAdornment: (
                                  <InputAdornment
                                    position="start"
                                    sx={{ color: "black" }}
                                  >
                                    <AttachMoneyIcon />
                                  </InputAdornment>
                                ),
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 1,
                                color: "#3B3B3B",
                                fontWeight: 600,
                                fontSize: "16px",
                                height: 45
                              },
                              "& .MuiInputLabel-outlined": {
                                color: "#3B3B3B",
                              },
                            }}
                            inputMode="numeric"
                          />
                          {message && (
                            <span
                              className={"font-normal text-center text-[#28A745] text-base"}
                            >
                              {message}
                            </span>
                          )}
                          {errors && (
                            <span
                              className={"font-normal text-center text-[#EF233C] text-[14px]"}
                            >
                              {errors}
                            </span>
                          )}
                        </Box>
                      )}
                    </Box>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Box>
          {/* Proxy Bid Card End*/}
          {/* Bid Protection Enable start */}
          <Box
            mt={2}
            sx={{ backgroundColor: "white", boxShadow: 3, borderRadius: 1, p: 2 }}
          >
            <FormControlLabel
              control={
                <Checkbox
                id="warning-checkbox"
                  checked={isBidProtectionEnable}
                  onChange={(e) => setIsBidProtectionEnable(e.target.checked)}
                  color="warning"
                />
              }
              label={
                <Typography className="text-[#3B3B3B] font-medium text-[14px] leading-[24px]">
                  Enable Bid Protection
                </Typography>
              }
            />
            <Typography
              sx={{ fontWeight: 400, fontSize: "14px", lineHeight: "18px" }}
            >
              <span className="font-semibold leading-[18px]">
                Bid Protection
              </span>{" "}
              ensures you don't lose an auction to another bidder offering the
              same amount as your proxy bid. If triggered, it will automatically
              increase your bid by up to $1,000, provided you have sufficient
              funds in your account. This additional bid will only be placed if
              you have at least $1,000 available.
            </Typography>
          </Box>
          {/* Bid Protection Enable end */}
          {/*Place Bid Button*/}
          <Box
            display="flex"
            flexDirection={"column"}
            alignItems="center"
            justifyContent="center"
            mt={2}
          >
            <Button
              variant="contained"
              size="large"
              sx={{
                px: 2,
                py: 1,
                backgroundColor: "#FF5C39",
                textTransform: "none",
                fontSize: 18,
                borderRadius: 2,
                marginBottom: 2
              }}
              id="place-bid-button"
              disabled={loading || buttonDisabled }
              onClick={
                OnUpdateProxyBid
              }
            >
              {loading ? 'Updating...' : PlaceBidText}
            </Button>




          </Box>
          {/*Place Bid Button*/}
        </Box>
      )}
    </Dialog>
  </>
);
}
